import { connect } from 'react-redux'
import AgreementDetail from '../components/agreement-detail';
import {showCheckAction} from '../action-creators/display-details';
import {changeCheckAction} from '../action-creators/display-details';
import {changeCheckLinkAction} from '../action-creators/display-details';

const mapDispatchToProps = (dispatch, props) => ({
    showCheck: () => dispatch(showCheckAction('')),   
    changeCheck: (valCheck) => dispatch(changeCheckAction(valCheck)),
    changeCheckLink: () => dispatch(changeCheckLinkAction(''))
});

const mapStateToProps =(state) => {
   console.log(`mapStateToProps -> ${JSON.stringify(state.formdetaildata)}`);
      return {
          checked:state.formdetaildata.checked
       };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AgreementDetail);
